// src/lib/stripeConnectClient.js
// Client-side helpers for Stripe Connect onboarding completion and status checks

import { authedFetch } from "./authedFetch";
import { apiUrl } from "../utils/apiBase";

async function readJsonSafe(res) {
  try {
    return await res.json();
  } catch {
    return null;
  }
}

/**
 * Finalize Stripe Connect onboarding after user returns from Stripe.
 * Calls /api/stripe/connect-finalize to fetch account status and persist flags.
 */
export async function finaliseConnect() {
  const primaryUrl = apiUrl("/stripe/connect-finalize");
  const legacyUrl = apiUrl("/stripe/connect-finalise");

  let res = await authedFetch(primaryUrl, {
    method: "POST",
    body: JSON.stringify({}),
  });

  if (res.status === 404) {
    res = await authedFetch(legacyUrl, { method: "POST", body: JSON.stringify({}) });
  }

  const json = await readJsonSafe(res);
  
  if (!res.ok) {
    const error = new Error(json?.error || json?.message || `Failed to finalise Stripe Connect (${res.status})`);
    error.status = res.status;
    error.data = json;
    throw error;
  }

  return json;
}

/**
 * Fetch current Stripe Connect status for a studio.
 * Calls /api/stripe/connect-status to get account details.
 */
export async function fetchConnectStatus(studioId = "default") {
  const url = apiUrl(`/stripe/connect-status?studioId=${encodeURIComponent(studioId)}`);
  const res = await authedFetch(url, {
    method: "GET",
  });

  const json = await readJsonSafe(res);

  if (!res.ok) {
    const error = new Error(json?.error || json?.message || `Failed to fetch Stripe Connect status (${res.status})`);
    error.status = res.status;
    error.data = json;
    throw error;
  }

  return json;
}
